"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledPhotoCarouselDots = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _PhotoCarouselDotsMixin = require("../../mixins/components/PhotoCarouselDotsMixin");
var StyledPhotoCarouselDots = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "StyledPhotoCarouselDots",
  componentId: "c11n-8-107-0__sc-bi0wwg-0"
})(["", ""], _PhotoCarouselDotsMixin.PhotoCarouselDotsMixin);
exports.StyledPhotoCarouselDots = StyledPhotoCarouselDots;